import classNames from 'classnames';
import { Button } from '../../../ui';
import st from './index.module.css';
import Link from 'next/link';

const Packages = () => {
  const handleScroll = () => {
    const section = document.getElementById('black-offer');
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div id="packages" className="bg-white py-[48px]">
      <div className="container flex flex-col items-center gap-[48px]">
        <div className="flex flex-col items-center gap-[18px]">
          <p className="md:text-[18px] text-[14px] text-[#000000] font-thin">Limited inventory · iGaming exclusive</p>
          <h2 className="text-center font-[500] text-[32px] md:text-[48px] leading-[39px] md:leading-[62px] text-[#000000]">
            World Cup 2026 Packages
          </h2>
          <div className="text-[18px] text-[#000000] text-center max-w-[518px] leading-[22px]">
            Choose your reach. Every package is built around your geo, your format mix, and your budget.
          </div>
        </div>
        <div className="hide_scrollbar overflow-x-auto overflow-y-visible h-[1150px]  w-full" style={{ WebkitOverflowScrolling: 'touch' }}>
          <div className="flex flex-row flex-nowrap gap-[16px] min-w-max text-white">
            <div className="relative flex flex-col justify-between gap-[10px] shrink-0 px-[24px] py-[32px] bg-[#000000] md:w-[360px] w-[330px] min-h-[1104px] transform-gpu transition-transform duration-200 ease-out hover:scale-[1.02]  hover:z-10 origin-top">
              <div className="flex flex-col gap-[24px]">
                <div className="bg-[#FCF8D2] px-[16px] py-[4px] text-[18px] font-[500] text-[#000000] rounded-[20px] max-w-max leading-[23px]">
                  Entry
                </div>
                <div className="flex flex-col gap-[16px]">
                  <p className="text-[24px] font-[500] text-[#FCF8D2] leading-[31px]">Kick-Off</p>
                  <p className="text-[18px] font-[500] leading-[23px]">One Geo. One Shot.</p>
                </div>
                <div className="flex flex-col items-center gap-[8px] border-y border-white py-[8px]">
                  <p className="text-[32px] font-[600] text-[#FCF8D2] leading-[42px]">from $15,000</p>
                  <p className="text-[14px] font-thin leading-[18px]">CPM or fixed · full tournament</p>
                  <p className="text-[18px] font-[600] leading-[23px]">~4–6M impressions</p>
                </div>
                <div className="flex flex-row gap-[10px] justify-start items-center">
                  <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.8805 0L5.72827 7.56287L2.28064 3.88367L0 6.02075L5.56982 11.9647L16 2.29749L13.8805 0Z" fill="#9EBF91" />
                  </svg>
                  <p className="text-[16px] font-[300] leading-[21px]">Telegram Advertising Network</p>
                </div>
                <div className="flex flex-row gap-[10px] justify-start items-center">
                  <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.8805 0L5.72827 7.56287L2.28064 3.88367L0 6.02075L5.56982 11.9647L16 2.29749L13.8805 0Z" fill="#9EBF91" />
                  </svg>
                  <p className="text-[16px] font-[300] leading-[21px]">Cinema Network (Ads on movie sites)</p>
                </div>
                <div className="flex flex-row gap-[10px] justify-start items-center">
                  <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.8805 0L5.72827 7.56287L2.28064 3.88367L0 6.02075L5.56982 11.9647L16 2.29749L13.8805 0Z" fill="#9EBF91" />
                  </svg>
                  <p className="text-[16px] font-[300] leading-[21px]">1 GEO coverage</p>
                </div>
                <div className="flex flex-row gap-[10px] justify-start items-center">
                  <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.8805 0L5.72827 7.56287L2.28064 3.88367L0 6.02075L5.56982 11.9647L16 2.29749L13.8805 0Z" fill="#9EBF91" />
                  </svg>
                  <p className="text-[16px] font-[300] leading-[21px]">Full tournament</p>
                </div>
                <div className="flex flex-row gap-[10px] justify-start items-center">
                  <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.8805 0L5.72827 7.56287L2.28064 3.88367L0 6.02075L5.56982 11.9647L16 2.29749L13.8805 0Z" fill="#9EBF91" />
                  </svg>
                  <p className="text-[16px] font-[300] leading-[21px]">Up to 10 creatives</p>
                </div>
                <div className="flex flex-row gap-[10px] justify-start items-center">
                  <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.8805 0L5.72827 7.56287L2.28064 3.88367L0 6.02075L5.56982 11.9647L16 2.29749L13.8805 0Z" fill="#9EBF91" />
                  </svg>
                  <p className="text-[16px] font-[300] leading-[21px]">End-of-campaign reporting</p>
                </div>
                <div className="flex flex-row gap-[10px] justify-start items-center">
                  <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.8805 0L5.72827 7.56287L2.28064 3.88367L0 6.02075L5.56982 11.9647L16 2.29749L13.8805 0Z" fill="#9EBF91" />
                  </svg>
                  <p className="text-[16px] font-[300] leading-[21px]">Daily optimisation</p>
                </div>
                <div className="flex flex-row gap-[10px] justify-start items-center">
                  <svg width="10" height="3" viewBox="0 0 10 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M9.54545 0H0.454545C0.203545 0 0 0.223867 0 0.5V2.5C0 2.77613 0.203545 3 0.454545 3H9.54545C9.79648 3 10 2.77613 10 2.5V0.5C10 0.223867 9.79648 0 9.54545 0Z"
                      fill="#A3A2A2"
                    />
                  </svg>
                  <p className="text-[16px] font-[300] leading-[21px] text-[#A3A2A2]">Sport Ads Network</p>
                </div>
                <div className="flex flex-row gap-[10px] justify-start items-center">
                  <svg width="10" height="3" viewBox="0 0 10 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M9.54545 0H0.454545C0.203545 0 0 0.223867 0 0.5V2.5C0 2.77613 0.203545 3 0.454545 3H9.54545C9.79648 3 10 2.77613 10 2.5V0.5C10 0.223867 9.79648 0 9.54545 0Z"
                      fill="#A3A2A2"
                    />
                  </svg>
                  <p className="text-[16px] font-[300] leading-[21px] text-[#A3A2A2]">PPC / SEO</p>
                </div>
                <div className="flex flex-row gap-[10px] justify-start items-center">
                  <svg width="10" height="3" viewBox="0 0 10 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M9.54545 0H0.454545C0.203545 0 0 0.223867 0 0.5V2.5C0 2.77613 0.203545 3 0.454545 3H9.54545C9.79648 3 10 2.77613 10 2.5V0.5C10 0.223867 9.79648 0 9.54545 0Z"
                      fill="#A3A2A2"
                    />
                  </svg>
                  <p className="text-[16px] font-[300] leading-[21px] text-[#A3A2A2]">Social Media Management</p>
                </div>
              </div>
              <div className="flex flex-col gap-[8px]">
                <p className="text-[16px] font-[600] leading-[21px]">Forecasted conversion potential </p>
                <p className="text-[16px] font-[300] leading-[21px]">Brand Awareness Growth · New Audience Acquisition · Player Traffic Increase</p>
                <Button variant="greenWorld" onClick={handleScroll}>
                  Get KPI Forecast
                </Button>
              </div>
            </div>
            <div className="relative flex flex-col justify-between gap-[10px] shrink-0 px-[24px] py-[32px] bg-[#000000] md:w-[360px] w-[330px] min-h-[1104px] transform-gpu transition-transform duration-200 ease-out hover:scale-[1.02]  hover:z-10 origin-top">
              <div className="flex flex-col gap-[24px]">
                <div className="bg-[#D5DD23] px-[16px] py-[4px] text-[18px] font-[500] text-[#000000] rounded-[20px] max-w-max leading-[23px]">
                  Most popular
                </div>
                <div className="flex flex-col gap-[16px]">
                  <p className="text-[24px] font-[500] text-[#D5DD23] leading-[31px]">Expansion</p>
                  <p className="text-[18px] font-[500] leading-[23px]">Cross-Channel. 2 GEOs.</p>
                </div>
                <div className="flex flex-col items-center gap-[8px] border-y border-white py-[8px]">
                  <p className="text-[32px] font-[600] text-[#D5DD23] leading-[42px]">from $30,000</p>
                  <p className="text-[14px] font-thin leading-[18px]">CPM or fixed · full tournament</p>
                  <p className="text-[18px] font-[600] leading-[23px]">~12–18M impressions</p>
                </div>
                <div className="flex flex-row gap-[10px] justify-start items-center">
                  <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.8805 0L5.72827 7.56287L2.28064 3.88367L0 6.02075L5.56982 11.9647L16 2.29749L13.8805 0Z" fill="#9EBF91" />
                  </svg>
                  <p className="text-[16px] font-[300] leading-[21px]">Telegram Advertising Network</p>
                </div>
                <div className="flex flex-row gap-[10px] justify-start items-center">
                  <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.8805 0L5.72827 7.56287L2.28064 3.88367L0 6.02075L5.56982 11.9647L16 2.29749L13.8805 0Z" fill="#9EBF91" />
                  </svg>
                  <p className="text-[16px] font-[300] leading-[21px]">Cinema Network (Ads on movie sites)</p>
                </div>
                <div className="flex flex-row gap-[10px] justify-start items-center">
                  <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.8805 0L5.72827 7.56287L2.28064 3.88367L0 6.02075L5.56982 11.9647L16 2.29749L13.8805 0Z" fill="#9EBF91" />
                  </svg>
                  <p className="text-[16px] font-[300] leading-[21px]">Sport Ads Network (Ads on sport sites)</p>
                </div>
                <div className="flex flex-row gap-[10px] justify-start items-center">
                  <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.8805 0L5.72827 7.56287L2.28064 3.88367L0 6.02075L5.56982 11.9647L16 2.29749L13.8805 0Z" fill="#9EBF91" />
                  </svg>
                  <p className="text-[16px] font-[300] leading-[21px]">2 GEOs coverage</p>
                </div>
                <div className="flex flex-row gap-[10px] justify-start items-center">
                  <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.8805 0L5.72827 7.56287L2.28064 3.88367L0 6.02075L5.56982 11.9647L16 2.29749L13.8805 0Z" fill="#9EBF91" />
                  </svg>
                  <p className="text-[16px] font-[300] leading-[21px]">Full tournament</p>
                </div>
                <div className="flex flex-row gap-[10px] justify-start items-center">
                  <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.8805 0L5.72827 7.56287L2.28064 3.88367L0 6.02075L5.56982 11.9647L16 2.29749L13.8805 0Z" fill="#9EBF91" />
                  </svg>
                  <p className="text-[16px] font-[300] leading-[21px]">Up to 30 creatives</p>
                </div>
                <div className="flex flex-row gap-[10px] justify-start items-center">
                  <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.8805 0L5.72827 7.56287L2.28064 3.88367L0 6.02075L5.56982 11.9647L16 2.29749L13.8805 0Z" fill="#9EBF91" />
                  </svg>
                  <p className="text-[16px] font-[300] leading-[21px]">Bi-weekly reporting</p>
                </div>
                <div className="flex flex-row gap-[10px] justify-start items-center">
                  <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.8805 0L5.72827 7.56287L2.28064 3.88367L0 6.02075L5.56982 11.9647L16 2.29749L13.8805 0Z" fill="#9EBF91" />
                  </svg>
                  <p className="text-[16px] font-[300] leading-[21px]">Personal ad dashboard</p>
                </div>
                <div className="flex flex-row gap-[10px] justify-start items-center">
                  <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.8805 0L5.72827 7.56287L2.28064 3.88367L0 6.02075L5.56982 11.9647L16 2.29749L13.8805 0Z" fill="#9EBF91" />
                  </svg>
                  <p className="text-[16px] font-[300] leading-[21px]">Daily optimisation</p>
                </div>
                <div className="flex flex-row gap-[10px] justify-start items-center">
                  <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.8805 0L5.72827 7.56287L2.28064 3.88367L0 6.02075L5.56982 11.9647L16 2.29749L13.8805 0Z" fill="#9EBF91" />
                  </svg>
                  <p className="text-[16px] font-[300] leading-[21px]">Dedicated Account Manager</p>
                </div>
                <div className="flex flex-row gap-[10px] justify-start items-center">
                  <svg width="10" height="3" viewBox="0 0 10 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M9.54545 0H0.454545C0.203545 0 0 0.223867 0 0.5V2.5C0 2.77613 0.203545 3 0.454545 3H9.54545C9.79648 3 10 2.77613 10 2.5V0.5C10 0.223867 9.79648 0 9.54545 0Z"
                      fill="#A3A2A2"
                    />
                  </svg>
                  <p className="text-[16px] font-[300] leading-[21px] text-[#A3A2A2]">PPC / SEO</p>
                </div>
                <div className="flex flex-row gap-[10px] justify-start items-center">
                  <svg width="10" height="3" viewBox="0 0 10 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M9.54545 0H0.454545C0.203545 0 0 0.223867 0 0.5V2.5C0 2.77613 0.203545 3 0.454545 3H9.54545C9.79648 3 10 2.77613 10 2.5V0.5C10 0.223867 9.79648 0 9.54545 0Z"
                      fill="#A3A2A2"
                    />
                  </svg>
                  <p className="text-[16px] font-[300] leading-[21px] text-[#A3A2A2]">Social Media Management</p>
                </div>
              </div>
              <div className="flex flex-col gap-[8px]">
                <p className="text-[16px] font-[600] leading-[21px]">Forecasted conversion potential </p>
                <p className="text-[16px] font-[300] leading-[21px]">Registration Growth · Deposit Opportunity Increase · Revenue Scaling</p>
                <Button variant="greenWorld" onClick={handleScroll}>
                  Get KPI Forecast
                </Button>
              </div>
            </div>
            <div className="relative flex flex-col justify-between gap-[10px] shrink-0 px-[24px] py-[32px] bg-[#000000] md:w-[360px] w-[330px] min-h-[1104px] transform-gpu transition-transform duration-200 ease-out hover:scale-[1.02]  hover:z-10 origin-top">
              <div className="flex flex-col gap-[24px]">
                <div className="bg-[#FAC8A5] px-[16px] py-[4px] text-[18px] font-[500] text-[#000000] rounded-[20px] max-w-max leading-[23px]">
                  Maximum visibility
                </div>
                <div className="flex flex-col gap-[16px]">
                  <p className="text-[24px] font-[500] text-[#FAC8A5] leading-[31px]">Dominance</p>
                  <p className="text-[18px] font-[500] leading-[23px]">Peak Visibility. Multi-GEO</p>
                </div>
                <div className="flex flex-col items-center gap-[8px] border-y border-white py-[8px]">
                  <p className="text-[32px] font-[600] text-[#FAC8A5] leading-[42px]">from $60,000</p>
                  <p className="text-[14px] font-thin leading-[18px]">Fixed · full tournament · premium inventory</p>
                  <p className="text-[18px] font-[600] leading-[23px]">~25–40M+ impressions</p>
                </div>
                <div className="flex flex-row gap-[10px] justify-start items-center">
                  <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.8805 0L5.72827 7.56287L2.28064 3.88367L0 6.02075L5.56982 11.9647L16 2.29749L13.8805 0Z" fill="#9EBF91" />
                  </svg>
                  <p className="text-[16px] font-[300] leading-[21px]">Telegram Advertising Network</p>
                </div>
                <div className="flex flex-row gap-[10px] justify-start items-center">
                  <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.8805 0L5.72827 7.56287L2.28064 3.88367L0 6.02075L5.56982 11.9647L16 2.29749L13.8805 0Z" fill="#9EBF91" />
                  </svg>
                  <p className="text-[16px] font-[300] leading-[21px]">Cinema Network (Ads on movie sites)</p>
                </div>
                <div className="flex flex-row gap-[10px] justify-start items-center">
                  <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.8805 0L5.72827 7.56287L2.28064 3.88367L0 6.02075L5.56982 11.9647L16 2.29749L13.8805 0Z" fill="#9EBF91" />
                  </svg>
                  <p className="text-[16px] font-[300] leading-[21px]">Sport Ads Network (Ads on sport sites)</p>
                </div>
                <div className="flex flex-row gap-[10px] justify-start items-center">
                  <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.8805 0L5.72827 7.56287L2.28064 3.88367L0 6.02075L5.56982 11.9647L16 2.29749L13.8805 0Z" fill="#9EBF91" />
                  </svg>
                  <p className="text-[16px] font-[300] leading-[21px]">PPC + SEO support</p>
                </div>
                <div className="flex flex-row gap-[10px] justify-start items-center">
                  <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.8805 0L5.72827 7.56287L2.28064 3.88367L0 6.02075L5.56982 11.9647L16 2.29749L13.8805 0Z" fill="#9EBF91" />
                  </svg>
                  <p className="text-[16px] font-[300] leading-[21px]">Social Media Management</p>
                </div>
                <div className="flex flex-row gap-[10px] justify-start items-center">
                  <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.8805 0L5.72827 7.56287L2.28064 3.88367L0 6.02075L5.56982 11.9647L16 2.29749L13.8805 0Z" fill="#9EBF91" />
                  </svg>
                  <p className="text-[16px] font-[300] leading-[21px]">3 GEOs coverage</p>
                </div>
                <div className="flex flex-row gap-[10px] justify-start items-center">
                  <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.8805 0L5.72827 7.56287L2.28064 3.88367L0 6.02075L5.56982 11.9647L16 2.29749L13.8805 0Z" fill="#9EBF91" />
                  </svg>
                  <p className="text-[16px] font-[300] leading-[21px]">Full tournament</p>
                </div>
                <div className="flex flex-row gap-[10px] justify-start items-center">
                  <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.8805 0L5.72827 7.56287L2.28064 3.88367L0 6.02075L5.56982 11.9647L16 2.29749L13.8805 0Z" fill="#9EBF91" />
                  </svg>
                  <p className="text-[16px] font-[300] leading-[21px]">Unlimited daily match creatives</p>
                </div>
                <div className="flex flex-row gap-[10px] justify-start items-center">
                  <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.8805 0L5.72827 7.56287L2.28064 3.88367L0 6.02075L5.56982 11.9647L16 2.29749L13.8805 0Z" fill="#9EBF91" />
                  </svg>
                  <p className="text-[16px] font-[300] leading-[21px]">Daily reporting</p>
                </div>
                <div className="flex flex-row gap-[10px] justify-start items-center">
                  <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.8805 0L5.72827 7.56287L2.28064 3.88367L0 6.02075L5.56982 11.9647L16 2.29749L13.8805 0Z" fill="#9EBF91" />
                  </svg>
                  <p className="text-[16px] font-[300] leading-[21px]">Personal ad dashboard</p>
                </div>

                <div className="flex flex-row gap-[10px] justify-start items-center">
                  <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.8805 0L5.72827 7.56287L2.28064 3.88367L0 6.02075L5.56982 11.9647L16 2.29749L13.8805 0Z" fill="#9EBF91" />
                  </svg>
                  <p className="text-[16px] font-[300] leading-[21px]">Daily optimisation</p>
                </div>
                <div className="flex flex-row gap-[10px] justify-start items-center">
                  <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.8805 0L5.72827 7.56287L2.28064 3.88367L0 6.02075L5.56982 11.9647L16 2.29749L13.8805 0Z" fill="#9EBF91" />
                  </svg>
                  <p className="text-[16px] font-[300] leading-[21px]">Dedicated Account Manager</p>
                </div>
              </div>
              <div className="flex flex-col gap-[8px]">
                <p className="text-[16px] font-[600] leading-[21px]">Forecasted conversion potential </p>
                <p className="text-[16px] font-[300] leading-[21px]">
                  High-Volume FTD Growth · Multi-GEO Market Expansion · Maximum Revenue Potential
                </p>
                <Button variant="greenWorld" onClick={handleScroll}>
                  Get KPI Forecast
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Packages;
